'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    id: 'faq-001',
    q: 'How do I book the mobile van?',
    a: 'Simply click "Book Now", choose "Mobile Car Wash Van", enter your address, select your preferred date and time slot, and confirm. Our van will come to you anywhere in Curaçao.',
  },
  {
    id: 'faq-002',
    q: 'What areas does the mobile van cover?',
    a: 'Our mobile van covers all of Curaçao. East side is served from 7:00 AM to 12:00 PM, and the West side from 12:00 PM to 7:00 PM. Enter your address during booking and we will confirm availability.',
  },
  {
    id: 'faq-003',
    q: 'Can I book for the same day?',
    a: 'By default, same-day bookings are disabled to ensure quality service. Earliest available booking is the next day. In special cases, contact us via WhatsApp and we will do our best.',
  },
  {
    id: 'faq-004',
    q: 'How does the loyalty program work?',
    a: 'Every paid wash earns you one stamp. After 4 paid washes, your 5th wash is completely free. Progress is tracked automatically in your customer dashboard.',
  },
  {
    id: 'faq-005',
    q: 'What payment methods do you accept?',
    a: 'We accept Sentoo, online banking, swipe/card payment on-site, and cash. Payment confirmation is handled by our team after your appointment.',
  },
  {
    id: 'faq-006',
    q: 'Can I cancel or reschedule my appointment?',
    a: 'Cancellation and rescheduling options are available when enabled by our team. You can request a change from your customer dashboard, and our manager will confirm or contact you.',
  },
  {
    id: 'faq-007',
    q: 'What is included in the monthly subscription?',
    a: 'The 250 XCG/month subscription includes 4 washes per month (1 per week), basic inside wash, full outside wash, and tire shine every visit. Washes can be at our location or via the mobile van.',
  },
  {
    id: 'faq-008',
    q: 'Do you take before and after photos?',
    a: 'Yes! Our employees take before and after photos of every service. These are stored in your vehicle record and can be approved for use on our social media with your permission.',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>('faq-001');

  return (
    <section className="py-20 bg-background" id="faq">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 xl:px-16">
        <div className="text-center mb-12">
          <span className="inline-block bg-sky-100 text-primary text-sm font-semibold px-4 py-1.5 rounded-full mb-3">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-dark">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-white rounded-2xl border border-sky-100 overflow-hidden shadow-card"
            >
              <button
                onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-sky-50/50 transition-colors"
              >
                <span className="font-semibold text-dark text-sm md:text-base">{faq?.q}</span>
                <ChevronDown
                  size={18}
                  className={`text-primary flex-shrink-0 ml-4 transition-transform duration-200 ${
                    openId === faq?.id ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openId === faq?.id && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}